export const roundNumber = (value: number, decimals = 2): number => {
  const factorOfTen = Math.pow(10, decimals);

  return Math.round((value + Number.EPSILON) * factorOfTen) / factorOfTen;
};

export const formatPaymentToken = (token: string): string =>
  token.replace("_POLYGON", "").replace("_BSC", "");
